// Generated from brands/urovision/brand.toml - do not edit.
package chat.amp.tim

import androidx.compose.ui.graphics.Color
import chat.amp.tim.resources.Res
import chat.amp.tim.resources.brand_logo_end
import chat.amp.tim.resources.brand_logo_start

internal val Brand: BrandSpec = BrandSpec(
    id = "urovision",
    urls = BrandUrls(
        privacy = "https://tim-cherry.de/privacy",
        imprint = "https://tim-cherry.de/agb",
        push = "https://tim-cherry.de/_matrix/push/v1/notify",
        versionCheck = "https://updates.ti-messenger.chat/version.json",
    ),
    tim = BrandTim(
        clientId = "awesome_tim_01",
    ),
    features = BrandFeatures(
        contentScanning = false,
        downloadsDisabled = false,
        themeComponents = ThemeComponentSet.FLAT,
    ),
    logos = listOf(
        BrandLogo(Res.drawable.brand_logo_start, LogoSlot.START, 32),
        BrandLogo(Res.drawable.brand_logo_end, LogoSlot.END, 32),
    ),
    palette = BrandPalette(
        accent = Color(0xFFFFFFFF),
        light = BrandColors(
            primary = BrandColor.Fixed(Color(0xFF86BD40)),
            onPrimary = BrandColor.Fixed(Color(0xFF1B1B1B)),
            primaryContainer = BrandColor.Fixed(Color(0xFFEBF4DF)),
            onPrimaryContainer = BrandColor.Fixed(Color(0xFF222F10)),
            secondary = BrandColor.Fixed(Color(0xFF229CD2)),
            onSecondary = BrandColor.Fixed(Color(0xFF001F2A)),
            secondaryContainer = BrandColor.Fixed(Color(0xFFDAEEF8)),
            onSecondaryContainer = BrandColor.Fixed(Color(0xFF082734)),
            tertiary = BrandColor.Fixed(Color(0xFFDAEEF8)),
            onTertiary = BrandColor.Fixed(Color(0xFF082734)),
            tertiaryContainer = BrandColor.Fixed(Color(0xFFE8EAE7)),
            onTertiaryContainer = BrandColor.Fixed(Color(0xFF1B1C1B)),
            error = BrandColor.Fixed(Color(0xFFBA1A1A)),
            errorContainer = BrandColor.Fixed(Color(0xFFFFDAD6)),
            onError = BrandColor.Fixed(Color(0xFFFFFFFF)),
            onErrorContainer = BrandColor.Fixed(Color(0xFF93000A)),
            background = BrandColor.Fixed(Color(0xFFFAFBF9)),
            onBackground = BrandColor.Fixed(Color(0xFF1B1C1B)),
            surface = BrandColor.Fixed(Color(0xFFFAFBF9)),
            onSurface = BrandColor.Fixed(Color(0xFF1B1C1B)),
            surfaceVariant = BrandColor.Fixed(Color(0xFFE6E9E3)),
            onSurfaceVariant = BrandColor.Fixed(Color(0xFF44483F)),
            outline = BrandColor.Fixed(Color(0xFF74796F)),
            inverseOnSurface = BrandColor.Fixed(Color(0xFFF2F3F0)),
            inverseSurface = BrandColor.Fixed(Color(0xFF30312F)),
            inversePrimary = BrandColor.Fixed(Color(0xFFAED380)),
            surfaceTint = BrandColor.Fixed(Color(0xFF86BD40)),
            outlineVariant = BrandColor.Fixed(Color(0xFFC4C8BF)),
            scrim = BrandColor.Fixed(Color(0xFF000000)),
            surfaceDim = BrandColor.Fixed(Color(0xFFDADBD8)),
            surfaceBright = BrandColor.Fixed(Color(0xFFFAFBF9)),
            surfaceContainerLowest = BrandColor.Fixed(Color(0xFFFFFFFF)),
            surfaceContainerLow = BrandColor.Fixed(Color(0xFFF4F5F2)),
            surfaceContainer = BrandColor.Fixed(Color(0xFFEEEFEA)),
            surfaceContainerHigh = BrandColor.Fixed(Color(0xFFE8E9E5)),
            surfaceContainerHighest = BrandColor.Fixed(Color(0xFFE2E3DF)),
        ),
        dark = BrandColors(
            primary = BrandColor.Fixed(Color(0xFF86BD40)),
            onPrimary = BrandColor.Fixed(Color(0xFF1B1B1B)),
            primaryContainer = BrandColor.Fixed(Color(0xFFEBF4DF)),
            onPrimaryContainer = BrandColor.Fixed(Color(0xFF222F10)),
            secondary = BrandColor.Fixed(Color(0xFF229CD2)),
            onSecondary = BrandColor.Fixed(Color(0xFF001F2A)),
            secondaryContainer = BrandColor.Fixed(Color(0xFFDAEEF8)),
            onSecondaryContainer = BrandColor.Fixed(Color(0xFF082734)),
            tertiary = BrandColor.Fixed(Color(0xFFDAEEF8)),
            onTertiary = BrandColor.Fixed(Color(0xFF082734)),
            tertiaryContainer = BrandColor.Fixed(Color(0xFFE8EAE7)),
            onTertiaryContainer = BrandColor.Fixed(Color(0xFF1B1C1B)),
            error = BrandColor.Fixed(Color(0xFFBA1A1A)),
            errorContainer = BrandColor.Fixed(Color(0xFFFFDAD6)),
            onError = BrandColor.Fixed(Color(0xFFFFFFFF)),
            onErrorContainer = BrandColor.Fixed(Color(0xFF93000A)),
            background = BrandColor.Fixed(Color(0xFFFAFBF9)),
            onBackground = BrandColor.Fixed(Color(0xFF1B1C1B)),
            surface = BrandColor.Fixed(Color(0xFFFAFBF9)),
            onSurface = BrandColor.Fixed(Color(0xFF1B1C1B)),
            surfaceVariant = BrandColor.Fixed(Color(0xFFE6E9E3)),
            onSurfaceVariant = BrandColor.Fixed(Color(0xFF44483F)),
            outline = BrandColor.Fixed(Color(0xFF74796F)),
            inverseOnSurface = BrandColor.Fixed(Color(0xFFF2F3F0)),
            inverseSurface = BrandColor.Fixed(Color(0xFF30312F)),
            inversePrimary = BrandColor.Fixed(Color(0xFFAED380)),
            surfaceTint = BrandColor.Fixed(Color(0xFF86BD40)),
            outlineVariant = BrandColor.Fixed(Color(0xFFC4C8BF)),
            scrim = BrandColor.Fixed(Color(0xFF000000)),
            surfaceDim = BrandColor.Fixed(Color(0xFFDADBD8)),
            surfaceBright = BrandColor.Fixed(Color(0xFFFAFBF9)),
            surfaceContainerLowest = BrandColor.Fixed(Color(0xFFFFFFFF)),
            surfaceContainerLow = BrandColor.Fixed(Color(0xFFF4F5F2)),
            surfaceContainer = BrandColor.Fixed(Color(0xFFEEEFEA)),
            surfaceContainerHigh = BrandColor.Fixed(Color(0xFFE8E9E5)),
            surfaceContainerHighest = BrandColor.Fixed(Color(0xFFE2E3DF)),
        ),
    ),
)
